import { marked } from 'marked';
import htmlToReact from './htmlToReact';

export default function Markdownify(markdown) {
	if (!markdown) {
		return null;
	}
	return htmlToReact(marked.parse(markdown));
}
